import React from 'react';
import { useParams } from 'react-router-dom';
import UpdateOfficials from './UpdateOfficials';


function EditOfficialsPage() {
    const { official_id, cogen_id, plantName } = useParams(); // get both params properly

    return ( 
        <div className="container-fluid">
            <UpdateOfficials official_id={official_id} cogen_id={cogen_id} plantName={plantName} />
        </div>
    );
}

export default EditOfficialsPage;
